/** @format */

import React, { type FC, useState } from "react";
import { useTranslation } from "react-i18next";
import theme from "../../../styles/theme";
import Box from "../../atoms/box/Box";
import Typography from "../../atoms/typography/Typography";
import IdeaCard from "../../molecules/cards/IdeaCard";
import List from "../../molecules/list/List";
import SegmentControl from "../../molecules/tabs/SegmentControl";
import Toolbar from "../../molecules/toolbar/Toolbar";
import type { ProfileTemplateProps } from "./ProfileTemplate.types";

const ProfileTemplate: FC<ProfileTemplateProps> = ({
  user,
  project,
  ideaMap,
  profilePageUser,
  accountOwner,
  profilePageIdeas,
  mapBounds,
  handle,
  checkedSortOption,
  setCheckedSortOption,
  setSearchTerm,
  searchTerm,
  setSearchOpen,
  searchOpen,
}) => {
  const { t } = useTranslation();

  const [order, setOrder] = useState(1);

  return (
    <div className=" min-h-screen px-5">
      <Box margin="20px 0px 10px 0px" gap="10px">
        <SegmentControl
          tabs={[
            {
              label: t("global:posts"),
              icon: "bulb",
            },
          ]}
          order={order}
          setOrder={setOrder}
          inActiveColor={theme.colors.palette.black}
        />
      </Box>

      {profilePageUser?.ideas?.length > 0 && (
        <Toolbar
          setSearchOpen={setSearchOpen}
          searchOpen={searchOpen}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          searchPlaceholder={t("global:searchBarPlaceholder")}
          checkedSortOption={checkedSortOption}
          setCheckedSortOption={setCheckedSortOption}
          sortOptions={[
            { value: "newest", label: t("global:newest") },
            { value: "hottest", label: t("global:hottest") },
          ]}
        />
      )}

      {!mapBounds && accountOwner ? (
        <Box
          gap="10px"
          justifyContent="center"
          flexDirection="column"
          marginTop="20px"
        >
          <Typography variant="bodyBg" textAlign="center">
            {profilePageUser?.ideas?.length === 0 &&
              t("auth:profile.accountOwnerNoIdeas")}
          </Typography>
        </Box>
      ) : (
        !mapBounds &&
        !accountOwner &&
        profilePageUser?.ideas?.length === 0 && (
          <Box
            gap="10px"
            justifyContent="center"
            flexDirection="column"
            marginTop="20px"
          >
            <Typography variant="bodyBg" textAlign="center">
              {t("auth:profile.noIdeas")}
            </Typography>
          </Box>
        )
      )}
      <List
        user={user}
        project={project}
        CardType={IdeaCard}
        ideaMap={ideaMap}
        lightCard={true}
        data={profilePageIdeas}
        handle={handle}
        listEndText={
          mapBounds && profilePageIdeas < 1
            ? t("auth:profile.noIdeasWithMapfilter")
            : profilePageIdeas > 0
              ? t("global:noMorePosts")
              : null

          //
        }
      />
    </div>
  );
};

export default ProfileTemplate;
